<template>
  <div class="multiscan-box" v-if="hasItem">
    <v-row dense>
      <v-col cols="6">
        <SubHeader :text="fullTitle" small/>
      </v-col>
      <v-col cols="6" class="d-flex align-center">
        <SubHeader :text="name" small/>
      </v-col>
      <v-col cols="6" class="d-flex align-center">
        <span class="multiscan-box__text">{{ host }}</span>
      </v-col>
      <v-col cols="6" class="d-flex align-center">
        <span class="multiscan-box__text">{{ port }}</span>
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn x-small :title="$t('GLOBAL-MESSAGE-EDIT')" color="grey" icon @click="edit">
          <v-icon small color="#404046">mdi-pencil</v-icon>
        </v-btn>
        <v-btn x-small :title="$t('GLOBAL-MESSAGE-DELETE')" color="grey" icon @click="deleteItem">
          <v-icon small color="#404046">mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SubHeader from "../ui-elements/SubHeader.vue";

export default {
  name: "MultiscanBox",
  components: {
    SubHeader,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {},
  computed: {
    number() {
      return this.index + 1;
    },
    hasIndex() {
      return this.index !== undefined;
    },
    fullTitle() {
      if (this.hasIndex) return `${this.title} #${this.number}`;
      return this.title;
    },
    hasItem() {
      return this.item && Object.entries(this.item).length > 0;
    },
    name() {
      if (this.item && !this.item.name) return "";
      return this.item.name;
    },
    host() {
      if (this.item && !this.item.host) return "";
      return this.item.host;
    },
    port() {
      if (this.item && !this.item.port) return "";
      return this.item.port;
    },
  },
  methods: {
    edit(){
      this.$emit('edit', {scan: this.item, index: this.index});
    },
    deleteItem(){
      this.$emit('deleteScan', this.index);
    }
  },
};
</script>

<style lang="scss" scoped>
  .multiscan-box{
    background: #F0F0F0;
    margin: .15em .25em;
    padding: .5em 1em;

    &__text{
      font-size: 12px;
    }
  }
</style>
